"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SrtConnectionStatus = void 0;
exports.isRtpOverSrt = isRtpOverSrt;
exports.isBondedSrtInputPort = isBondedSrtInputPort;
const types_1 = require("./api/v1/types");
var SrtConnectionStatus;
(function (SrtConnectionStatus) {
    SrtConnectionStatus["connected"] = "connected";
    SrtConnectionStatus["disconnected"] = "disconnected";
})(SrtConnectionStatus || (exports.SrtConnectionStatus = SrtConnectionStatus = {}));
function isRtpOverSrt(p) {
    return p.mode === types_1.IpPortMode.srt && !!p.rtp;
}
function isBondedSrtInputPort(p) {
    return p.mode === types_1.IpPortMode.srt && 'failoverPriority' in p && typeof p.failoverPriority === 'number';
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3J0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3NydC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUEyRUEsb0NBSUM7QUFFRCxvREFJQztBQXJGRCwwQ0FBNEc7QUErRDVHLElBQVksbUJBR1g7QUFIRCxXQUFZLG1CQUFtQjtJQUMzQiw4Q0FBdUIsQ0FBQTtJQUN2QixvREFBNkIsQ0FBQTtBQUNqQyxDQUFDLEVBSFcsbUJBQW1CLG1DQUFuQixtQkFBbUIsUUFHOUI7QUFTRCxTQUFnQixZQUFZLENBQ3hCLENBQXlCO0lBRXpCLE9BQU8sQ0FBQyxDQUFDLElBQUksS0FBSyxrQkFBVSxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQTtBQUMvQyxDQUFDO0FBRUQsU0FBZ0Isb0JBQW9CLENBQ2hDLENBQVk7SUFFWixPQUFPLENBQUMsQ0FBQyxJQUFJLEtBQUssa0JBQVUsQ0FBQyxHQUFHLElBQUksa0JBQWtCLElBQUksQ0FBQyxJQUFJLE9BQU8sQ0FBQyxDQUFDLGdCQUFnQixLQUFLLFFBQVEsQ0FBQTtBQUN6RyxDQUFDIn0=